<template>
  <div class="login primary-bg">
    <div class="mdl-card m--4">
      <div class="mdl-card__title mdl-color-text--white">
        <img class="login__logo" :src="clientLogo" alt="Logo">
  		</div>
      <form @submit.prevent="submit" v-if="!success">
        <div class="mdl-card__supporting-text">
          <div class="login__field">
            <input
              class="login__field__input"
              :class="{ 'active': email && email.length }"
              type="text"
              id="email"
              v-model="email"
              required
            />
            <label
              class="login__field__label"
              for="username"
              v-text="'Email'"
            >
            </label>
          </div>
        </div>
        <div class="d--flex">
          <button
            type="submit"
            class="mdl-button mdl-js-button mdl-button--raised secondary-bg"
            v-text="'Submit'"
          >
          </button>
        </div>
      </form>
      <div v-else>
        <div class="mdl-card__supporting-text">
          <p>If this email matches a user in our database you should receive an email in the next few minutes with instructions on how to reset your password.</p>
        </div>
      </div>
    </div>
    <div v-if="!success" class="forgot-password m--2 text--center">
      <router-link to="/login">Go Back</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    email: '',
    success: false
  }),
  computed: {
    clientLogo () {
      return this.$store.getters.clientLogo
    }
  },
  methods: {
    submit () {
      window.axios.post(this.$store.getters.expressApi + 'forgot-password', {
        loginId: this.email,
        tenantId: this.$store.getters.faTenantId
      }).then(() => {
          this.success = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .mdl-card {
    border-radius: 5px;
  }

</style>